import type { SearchBadgeConfig } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import {
  INQUIRY_NO_DEAL_LABEL,
  INQUIRY_RECRUITMENT_TYPE_LABEL_MAP,
  INQUIRY_START_ASAP_LABELS,
  WORK_LOCATION_LABELS,
} from 'shared'
import type { InquirySearchToken } from './types'

export const inquirySearchBadgeConfig: SearchBadgeConfig<InquirySearchToken> = {
  my_division: {
    label: () => '自分の部署',
    color: 'green',
  },
  my_assignment: {
    label: () => '自身の担当',
    color: 'green',
  },
  no_deal: {
    label: () => INQUIRY_NO_DEAL_LABEL,
    color: 'green',
  },
  primary_division: {
    label: (t) => `主管部門:${t.name}`,
    color: 'lime',
  },
  sales_member: {
    label: (t) => `営業担当:${t.name}`,
    color: 'lime',
  },
  service_manager: {
    label: (t) => `SMG担当:${t.name}`,
    color: 'lime',
  },
  inquiry_status: {
    label: (t) => `ステータス:${t.name}`,
    color: 'cyan',
  },
  work_location: {
    label: (t) => `作業場所:${WORK_LOCATION_LABELS[t.value]}`,
    color: 'blue',
  },
  recruitment_type: {
    label: (t) => `募集形態:${INQUIRY_RECRUITMENT_TYPE_LABEL_MAP[t.value]}`,
    color: 'blue',
  },
  start_month: {
    label: (t) => `開始月:${t.value}`,
    color: 'blue',
  },
  start_asap: {
    label: () => INQUIRY_START_ASAP_LABELS.LABEL,
    color: 'blue',
  },
  amount_min: {
    label: (t) => `想定金額下限:${t.value}円`,
    color: 'purple',
  },
  amount_max: {
    label: (t) => `想定金額上限:${t.value}円`,
    color: 'purple',
  },
  contract_type: {
    label: (t) => `契約種別:${t.value}`,
    color: 'gray',
  },
  assign_status: {
    label: (t) => `アサイン状態:${t.value}`,
    color: 'gray',
  },
  assign_start_month: {
    label: (t) => `アサイン開始月:${t.value}`,
    color: 'gray',
  },
  exclude: {
    label: (t) => `除外:${t.value}`,
    color: 'destructive',
  },
  query: {
    label: (t) => t.value,
    color: 'secondary',
    darkRemoveButton: true,
  },
}
